module.exports = __webpack_public_path__ + "media/recipes/30-53aa726c.png";